import { render } from "./DetailBlock.vue?vue&type=template&id=005d07a8"
import script from "./DetailBlock.vue?vue&type=script&lang=js"
export * from "./DetailBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__